module.exports = __webpack_public_path__ + "static/img/ban-img.008a07fb.png";